export { FinalPriceAside } from './final-price-aside.component';
